import { getUserFunnelBreakdown, getUserFunnelMetrics } from "@/services/dashboardServices";

export default {
    namespaced: true,
    state: () => ({
        userFunnelData: null,
        userFunnelBreakdown: null,
    }),
    getters: {
        userFunnelData: (state) => state.userFunnelData,
        userFunnelBreakdown: (state) => state.userFunnelBreakdown,
    },
    mutations: {
        SET_USER_FUNNEL_DATA(state, data) {
            state.userFunnelData = data;
        },
        SET_USER_FUNNEL_BREAKDOWN(state, data) {
            state.userFunnelBreakdown = data;
        },
    },
    actions: {
        async getUserFunnelMetrics({ commit, dispatch }, query) {
            try {
                const { data } = await getUserFunnelMetrics(
                    query.StartAt || '',
                    query.EndAt || '',
                    query.CreatingPartner || ''
                );
                commit('SET_USER_FUNNEL_DATA', data);
                return data;
            } catch (error) {
                const { message, statusText } = error;
                dispatch(
                    'notifications/displayNotification',
                    { message: message ? message : statusText, type: 'danger' },
                    { root: true }
                );
                throw error;
            }
        },
        async getUserFunnelBreakdown({ commit, dispatch }, query) {
            try {
                const { data } = await getUserFunnelBreakdown(
                    query.StartAt || '',
                    query.EndAt || '',
                    query.stage ?? 0,
                    query.page ?? 1,
                    query.pageSize ?? 20,
                    query.CreatingPartner || ''
                );
                commit('SET_USER_FUNNEL_BREAKDOWN', data);
                return data;
            } catch (error) {
                const { message, statusText } = error;
                dispatch(
                    'notifications/displayNotification',
                    { message: message ? message : statusText, type: 'danger' },
                    { root: true }
                );
                throw error;
            }
        },
    },
};
